import type React from "react";
import { useState } from "react";
import { AppConfig } from "@/config";
import { DebugButton } from "./components/DebugButton";
import { DebugPanelContent } from "./components/DebugPanelContent";

const DebugPanel: React.FC = () => {
  const [visible, setVisible] = useState(false);

  // Hide debug panel in production environment
  if (!AppConfig.enableDebugMode && !AppConfig.enableDevTools) {
    return null;
  }

  const handleOpen = () => setVisible(true);
  const handleClose = () => setVisible(false);

  if (visible) {
    return <DebugPanelContent onClose={handleClose} />;
  }

  return <DebugButton onOpen={handleOpen} />;
};

export default DebugPanel;
